import { instance, objectToParams } from './api';

export const getTransfersList = (args) => instance.get(`/api/v1/transfers?${objectToParams(args)}`);

export const getTransfersById = (id) => instance.get(`/api/v1/transfers/${id}`);

export const getTransferStockById = (id, args) => instance.get(`/api/v1/transfers/${id}/stock?${objectToParams(args)}`);

export const postTransfers = (form) => instance.post(`/api/v1/transfers`, form);

export const postTransferStockById = (id, form) => instance.post(`/api/v1/transfers/${id}/stock`, form);

export const postTransfersFileEPH = (form) => instance.post(`/api/v1/transfers/files/eph`, form);

export const closeTransfer = (id) => instance.post(`/api/v1/transfers/${id}/close`, {});
export const closeTransferForced = (id) => instance.post(`/api/v1/transfers/${id}/close/accept-all`, {});
export const transitTransfer = (id) => instance.post(`/api/v1/transfers/${id}/transit`, {});

export const deleteTransfer = (id) => instance.delete(`/api/v1/transfers/${id}`);
